var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMediaIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 248,
    height: 248,
    viewBox: "0 0 248 248",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-media_icon"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 248,
    height: 248
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "media_icon",
    clipPath: "url(#clip-media_icon)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_388",
    "data-name": "\\uADF8\\uB8F9 388",
    transform: "translate(25.688 17.631)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_13",
    "data-name": "\\uD328\\uC2A4 13",
    d: "M407.536,253.477a79.952,79.952,0,0,0-79.952-79.951h0a79.951,79.951,0,0,0-79.952,79.951V386.264h159.9Z",
    transform: "translate(-231.141 -173.526)",
    fill: "#00b5e5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_17",
    "data-name": "\\uADF8\\uB8F9 17",
    transform: "translate(71.024 35.177)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD0C0\\uC6D0_3",
    "data-name": "\\uD0C0\\uC6D0 3",
    transform: "translate(0 0)",
    fill: "#fff",
    stroke: "#161619",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.737,
    cy: 26.737,
    rx: 26.737,
    ry: 26.737,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.737,
    cy: 26.737,
    rx: 25.737,
    ry: 25.737,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_24",
    "data-name": "\\uC120 24",
    y2: 53.475,
    transform: "translate(26.737 0)",
    fill: "#fff",
    stroke: "#161619",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_17",
    "data-name": "\\uD328\\uC2A4 17",
    d: "M408.642,398.207s-10.584-38.435,57.931-106.95",
    transform: "translate(-269.95 -202.007)",
    fill: "none",
    stroke: "#161619",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_18",
    "data-name": "\\uD328\\uC2A4 18",
    d: "M325.1,332.992s-33.571-60.159-83.7-112.52",
    transform: "translate(-229.633 -184.883)",
    fill: "none",
    stroke: "#161619",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_19",
    "data-name": "\\uD328\\uC2A4 19",
    d: "M225.879,442.752s79.18-25,168.821,0",
    transform: "translate(-225.879 -235.968)",
    fill: "none",
    stroke: "#161619",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("text", {
    id: "media_icon-2",
    "data-name": "media_icon",
    transform: "translate(-26 -26)",
    fill: "#707070",
    fontSize: 20,
    fontFamily: "AppleSDGothicNeo-Regular, Apple SD Gothic Neo"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 18
  }, "media_icon")), /*#__PURE__*/React.createElement("text", {
    id: "media_icon-3",
    "data-name": "media_icon",
    transform: "translate(-26 -26)",
    fill: "#707070",
    fontSize: 20,
    fontFamily: "AppleSDGothicNeo-Regular, Apple SD Gothic Neo"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 18
  }, "media_icon")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaIcon);
export default __webpack_public_path__ + "static/media/media_icon.f8a300ebcb0da5f35ff103e3af423316.svg";
export { ForwardRef as ReactComponent };